import {
  getByDcUuid, saveOrModify,
} from '@/services/internal/facility/config/ProductDateManagerConfig';

export default {
  namespace: 'productDateManagerConfig',

  state: {
    data: {
      consumingInitiateType:'LOGISTICS_ERP'
    },
  },

  effects: {
    *getByDcUuid({payload,callback},{call,put}){
      const response =yield call(getByDcUuid);
      if(callback) callback(response)
    },
    *saveProductDateConfig({payload,callback},{call,put}){
      const response =yield call(saveOrModify,payload);
      if(callback) callback(response)
    }
  },

  reducers: {

  }
}
